import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { ContentInsights as ContentInsightsType } from "../hooks/useSocialMediaReport";
import { BarList, ChartBox, SOURCE_COLOR } from "./ReportViz";

interface ContentInsightsProps {
  insights: ContentInsightsType;
}

export const ContentInsights: React.FC<ContentInsightsProps> = ({ insights }) => {
  const typeChartData = insights.byPostType.map((item) => ({
    name: item.postType,
    "Avg Engagement": item.avgEngagement,
    count: item.count,
  }));

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div>
          <h3 className="text-xs font-medium text-gray-500 mb-2">Engagement by Post Type</h3>
          {typeChartData.length > 0 ? (
            <ChartBox height={180}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={typeChartData}>
                  <XAxis dataKey="name" tick={{ fontSize: 11 }} axisLine={false} tickLine={false} />
                  <YAxis tick={{ fontSize: 11 }} axisLine={false} tickLine={false} width={35} />
                  <Tooltip />
                  <Bar dataKey="Avg Engagement" fill="#6366F1" radius={[3, 3, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </ChartBox>
          ) : (
            <p className="text-gray-400 text-sm">No data available</p>
          )}
        </div>

        <div>
          <h3 className="text-xs font-medium text-gray-500 mb-2">Top Categories</h3>
          {insights.byCategory.length > 0 ? (
            <BarList
              color={SOURCE_COLOR.website}
              rows={insights.byCategory.slice(0, 6).map((cat) => ({
                key: cat.category,
                label: cat.category,
                value: cat.avgEngagement,
                display: Math.round(cat.avgEngagement).toLocaleString(),
              }))}
            />
          ) : (
            <p className="text-gray-400 text-sm">No tagged content</p>
          )}
        </div>
      </div>
    </div>
  );
};
